function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M273.256,254.839c1.352,0,2.703-0.078,4.045-0.244c1.02-0.127,2.198-0.21,3.115-0.711 c1.924-1.054,1.945-2.976,1.643-4.866c-0.355-2.215-2.291-3.355-4.422-3.078c-2.26,0.295-4.668,0.227-6.711-0.889 c-3.98-2.17-4.996-7.74-3.213-11.669c1.069-2.356,3.229-3.916,5.764-4.351c1.311-0.225,2.684-0.163,3.996,0.008 c1.289,0.168,2.533-0.062,3.469-1.05c1.115-1.183,1.604-3.712,0.957-5.192c-1.148-2.638-4.836-2.524-7.258-2.524 c-4.325,0-8.734,1.067-12.26,3.655c-6.734,4.941-8.523,14.893-4.855,22.245C260.492,252.121,266.848,254.839,273.256,254.839z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294.586,251.81c1.178,3.244,5.689,2.369,8.385,2.369c1.729,0,3.354-0.577,4.012-2.347c0.143-0.34,0.258-0.69,0.387-1.034 c1.965-5.278,3.93-10.558,5.895-15.835c0.912-2.451,1.824-4.902,2.738-7.354c0.811-2.18,1.627-4.799-1.057-6.2 c-1.275-0.667-3.023-0.409-4.416-0.409c-1.816,0-3.57,0.452-4.268,2.367c-0.758,2.077-1.209,4.313-1.799,6.441 c-1.166,4.205-2.352,8.386-3.244,12.66c-1.223-6.049-3.217-11.978-4.938-17.897c-0.303-1.042-0.574-2.041-1.473-2.769 c-1.252-1.014-2.879-0.803-4.379-0.803c-1.602,0-3.264-0.177-4.496,1.086c-1.068,1.096-1.217,2.608-0.713,3.993 C288.342,234.656,291.465,243.232,294.586,251.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.504,251.81c1.182,3.243,5.689,2.369,8.387,2.369c1.729,0,3.354-0.577,4.01-2.347c0.143-0.34,0.258-0.69,0.387-1.034 c1.965-5.278,3.93-10.558,5.895-15.835c0.912-2.451,1.824-4.902,2.738-7.354c0.811-2.18,1.627-4.8-1.055-6.2 c-1.275-0.667-3.023-0.409-4.418-0.409c-1.816,0-3.568,0.451-4.266,2.367c-0.758,2.078-1.209,4.313-1.801,6.441 c-1.166,4.205-2.354,8.386-3.242,12.66c-1.229-6.048-3.217-11.976-4.938-17.897c-0.303-1.043-0.576-2.041-1.475-2.769 c-1.25-1.014-2.879-0.803-4.379-0.803c-1.602,0-3.262-0.177-4.494,1.086c-1.07,1.098-1.219,2.606-0.715,3.993 C323.262,234.656,326.383,243.232,329.504,251.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.051,339.017c-21.604,0-41.697-6.594-58.373-17.875H49.452c-12.181,0-22.09-9.907-22.09-22.09V179.878H215.12 c10.313-16.705,25.198-30.297,42.896-39.025l-230.653,0.016v-19.648c0-12.182,9.909-22.09,22.09-22.09h314.786 c12.18,0,22.09,9.908,22.09,22.09v19.623l-36.258,0.002c34.572,17.043,58.418,52.654,58.418,93.734 c0,14.758-3.064,29.125-8.969,42.379l14.17,13.172v-168.91c0-27.268-22.184-49.451-49.451-49.451H49.452 C22.183,71.77,0,93.954,0,121.221v177.832c0,27.268,22.184,49.451,49.452,49.451h314.009l-18.967-17.631 C331.756,336.232,318.035,339.017,304.051,339.017z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.194,219.976c-3.977,0-7.2,3.223-7.2,7.199v21.442c0,3.978,3.224,7.199,7.2,7.199h133.592 c-1.423-6.858-2.173-13.963-2.173-21.238c0-4.954,0.355-9.83,1.026-14.604L68.194,219.976L68.194,219.976z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M452.557,355.464l-73.453-68.279c10.396-14.891,16.51-32.989,16.51-52.524c0-50.75-41.143-91.894-91.893-91.894 s-91.892,41.143-91.892,91.894c0,50.75,41.142,91.891,91.892,91.891c18.236,0,35.215-5.332,49.508-14.494l74.93,69.654 c3.451,3.209,7.828,4.795,12.195,4.795c4.807,0,9.6-1.922,13.127-5.719C460.219,373.538,459.805,362.199,452.557,355.464z  M303.721,173.978c33.459,0,60.68,27.223,60.68,60.683c0,33.459-27.221,60.68-60.68,60.68s-60.68-27.221-60.68-60.68 C243.041,201.201,270.262,173.978,303.721,173.978z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgCvvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "458.275px",
    height: "458.275px",
    viewBox: "0 0 458.275 458.275",
    style: {
      enableBackground: "new 0 0 458.275 458.275"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvvIcon);
export default __webpack_public_path__ + "static/media/cvv-icon.4d02484a.svg";
export { ForwardRef as ReactComponent };